/* eslint-disable jsx-a11y/anchor-is-valid */
import '@/styles/chat.scss';
import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import { Strophe, $iq, $msg, $pres } from 'strophe.js';
import moment from 'moment';
import { getUser, checkLogin } from '@/utils/index';
import { initUser } from '@/services/saas/openfire';
import { getOpenfireUser } from '@/services/tscloud/openfire';
import { getPlatConfig } from '../../utils';

function randomString(len) {
  len = len || 32;
  var _chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
    _maxPos = _chars.length,
    _pwd = '';
  for (var i = 0; i < len; i++) {
    _pwd += _chars.charAt(Math.floor(Math.random() * _maxPos));
  }
  return _pwd;
}

class Openfire extends Component {
  state = {
    chatList: [],
    userList: [],
    tabList: [
      { id: 'chatList', name: '聊天室' },
      { id: 'members', name: '成员' },
    ],
    selectedId: 'chatList',
  };

  componentDidMount() {
    const { platformType } = getPlatConfig();
    if (platformType === 'tscloud') {
      this.initTscloud();
    } else {
      checkLogin({
        onLogin: () => {
          this.initSaas();
        },
      });
    }
  }

  // componentWillUnmount() {
  //   if (this.connection) {
  //     this.connection.flush();
  //     this.connection.sync = true;
  //     this.connection.disconnect();
  //   }
  // }

  initSaas = async () => {
    const { nickName, userId } = getUser() || {};
    if (userId) {
      const { groupId } = this.props;
      const responsive = await initUser({
        account: userId,
        nickname: nickName,
      });
      if (responsive.success) {
        const { serviceName, mucServiceName, password } = responsive.data;
        const { protocol, host } = window.location;
        const openfireInfo = {
          serviceName,
          mucServiceName,
          httpBind: `${protocol}//${host}/http-bind/`,
          password,
          resource: `web_${randomString(3)}`,
        };
        this.openfireInfo = openfireInfo;
        this.openfireUserName = nickName;
        this.openfireName = nickName;
        this.jid = `${userId}@${openfireInfo.serviceName}/${openfireInfo.resource}`;
        this.ROOM_JID = `${groupId}@${openfireInfo.mucServiceName}`;
        this.reconnect();
      } else {
        Toast.info(responsive.message);
      }
    }
  };

  initTscloud = async () => {
    const { loginName, userId, userName } = getUser() || {};
    if (userId) {
      const { protocol, host } = window.location;
      const { groupId } = this.props;
      const openfireInfo = {
        serviceName: 'sanbu.openfire.com',
        mucServiceName: 'conference.sanbu.openfire.com',
        httpBind: `${protocol}//${host}/http-bind/`,
        password: 'xungejiaoyu',
        resource: `web_${randomString(3)}`,
      };
      this.openfireInfo = openfireInfo;
      this.RESOURCE = openfireInfo.resource;
      this.openfireUserName = userName;
      this.openfireName = loginName;
      this.jid = `${loginName}@${openfireInfo.serviceName}/${openfireInfo.resource}`;
      this.ROOM_JID = `${groupId}@${openfireInfo.mucServiceName}`;
      await getOpenfireUser({ name: userName, username: loginName });
      this.reconnect();
    }
  };

  reconnect = () => {
    if (!this.connection) {
      this.connection = new Strophe.Connection(this.openfireInfo.httpBind);
    }
    if (!this.connection.connected) {
      this.connection.connect(this.jid, this.openfireInfo.password, this.onConnect);
    }
  };

  onConnect = (status) => {
    if (status === Strophe.Status.CONNFAIL) {
      Toast.info('连接创建失败！');
    } else if (status === Strophe.Status.AUTHFAIL) {
      Toast.info('登录验证失败！');
    } else if (status === Strophe.Status.DISCONNECTED) {
      Toast.info('连接已关闭！');
      this.connected = false;
      if (this.num < 5) {
        this.num++;
        this.reconnect();
      } else {
        Toast.info('聊天室连接失败，网络不通或者您已经在其他地方登录！');
      }
    } else if (status === Strophe.Status.CONNECTED) {
      if (!this.connected) {
        // 当接收到<message>节，调用onMessage回调函数
        this.connection.addHandler(this.onMessage, null, 'message', null, null, null);
        this.connection.addHandler(this.onIq, null, 'iq', null, null, null);
        this.connection.addHandler(this.onPresence, null, 'presence', null, null, null);
      }
      this.connected = true;
      // 首先要发送一个<presence>给服务器（initial presence）
      const _pres = $pres({
        from: this.jid,
      })
        .c('show')
        .t('chat')
        .up()
        .c('status')
        .t('chat');
      this.connection.send(_pres.tree());
      this.connection.send(
        $pres({
          from: this.jid,
          to: this.ROOM_JID + '/' + this.openfireName,
        })
          .c('x', {
            xmlns: 'http://jabber.org/protocol/muc',
          })
          .c('history', {
            maxstanzas: '100',
          })
          .tree(),
      );
      this.connection.sendIQ(
        $iq({
          id: randomString(10),
          from: this.jid,
          to: this.ROOM_JID,
          type: 'get',
        })
          .c('query', {
            xmlns: 'http://jabber.org/protocol/disco#items',
          })
          .tree(),
        (msg) => {
          const _iq = $iq({
            id: randomString(10),
            from: this.jid,
            to: this.ROOM_JID,
            type: 'set',
          })
            .c('query', {
              xmlns: 'http://jabber.org/protocol/muc#owner',
            })
            .c('x', {
              xmlns: 'jabber:x:data',
              type: 'submit',
            })
            .c('field', {
              var: 'FORM_TYPE',
            })
            .c('value', {}, 'http://jabber.org/protocol/muc#roomconfig')
            .up()
            .c('field', {
              var: 'muc#roomconfig_roomname',
            })
            .c('value', {}, '聊天室名称')
            .up()
            .c('field', {
              var: 'muc#roomconfig_roomdesc',
            })
            .c('value', {}, '聊天室描述')
            .up()
            .c('field', {
              var: 'muc#roomconfig_enablelogging',
            })
            .c('value', {}, 1)
            .up()
            .c('field', {
              var: 'muc#roomconfig_changesubject',
            })
            .c('value', {}, 1)
            .up()
            .c('field', {
              var: 'muc#roomconfig_allowinvites',
            })
            .c('value', {}, 1)
            .up()
            .c('field', {
              var: 'muc#roomconfig_maxusers',
            })
            .c('value', {}, 1000)
            .up()
            .c('field', {
              var: 'muc#roomconfig_publicroom',
            })
            .c('value', {}, 1)
            .up()
            .c('field', {
              var: 'muc#roomconfig_persistentroom',
            })
            .c('value', {}, 1)
            .up()
            .c('field', {
              var: 'muc#roomconfig_moderatedroom',
            })
            .c('value', {}, 0);
          Strophe.serialize(_iq);
          this.connection.sendIQ(_iq.tree());
        },
      );
    }
  };

  decodeHTML = (str) => {
    str = str.replace(/&amp;/g, '&');
    str = str.replace(/&lt;/g, '<');
    str = str.replace(/&gt;/g, '>');
    str = str.replace(/&quot;/g, '"');
    str = str.replace(/&apos;/g, "'");
    return str;
  };

  onMessage = (msg) => {
    const { userId: id } = getUser();
    const { chatList } = this.state;
    Strophe.info(Strophe.serialize(msg));
    //解析出<message>的from、type属性，以及body子元素
    const from = msg.getAttribute('from'),
      type = msg.getAttribute('type'),
      elems = msg.getElementsByTagName('body'),
      userId = msg.getAttribute('userId'),
      photo = msg.getAttribute('photo');
    if (type === 'groupchat' && elems.length > 0) {
      let body = elems[0],
        msgBody = Strophe.getText(body),
        fromname = from.substring(from.indexOf('/') + 1),
        time = body.getAttribute('stamp');
      try {
        fromname = decodeURIComponent(fromname);
        msgBody = this.decodeHTML(msgBody);
        time = time ? time.substring(11, 16) : '';
      } catch (ex) {}
      chatList.push({
        user: fromname,
        text: msgBody,
        time: time,
        photo,
        isMine: userId === id,
      });
      this.setState(
        {
          chatList,
        },
        () => {
          const messageList = this.refs.messageList;
          if (messageList && messageList.scrollHeight) {
            messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight;
          }
        },
      );
    }
    return true;
  };

  onIq = (msg) => {
    Strophe.info(Strophe.serialize(msg));
    return true;
  };

  onPresence = (msg) => {
    const { userList } = this.state;
    const from = msg.getAttribute('from'),
      type = msg.getAttribute('type');
    let flag = false,
      num = null;
    if (from.indexOf('/') !== -1 && from.indexOf(this.ROOM_JID) !== -1) {
      const nickname = from.substring(from.indexOf('/') + 1);
      let nickid = nickname;
      if (nickname.indexOf('(') !== -1 && nickname.indexOf(')') !== -1) {
        nickid = nickname.substring(nickname.indexOf('(') + 1, nickname.indexOf(')'));
      }
      const val = {
        id: nickid,
        userName: decodeURIComponent(nickname),
      };
      for (let i = 0; i < userList.length; i++) {
        if (JSON.stringify(userList[i]).indexOf(JSON.stringify(val)) !== -1) {
          flag = true;
          num = i;
        }
      }
      if (type === 'unavailable') {
        //离开
        if (flag) {
          userList.splice(num, 1);
        }
      } else {
        if (!flag) {
          userList.push(val);
        }
      }
    }
    Strophe.info(Strophe.serialize(msg));
    this.setState({ userList });
    return true;
  };

  sendMsg = () => {
    const { userId, photo } = getUser() || {};
    if (!userId) {
      Toast.info('请先登录');
      return;
    }
    const msgInput = this.refs.messageInput;
    if (msgInput.value) {
      // 创建一个<message>元素并发送
      const msg = $msg({
        to: this.ROOM_JID,
        from: this.jid,
        type: 'groupchat',
        userId,
        photo,
      }).c(
        'body',
        {
          isAnonymity: false,
          stamp: moment().format('YYYY-MM-DD hh:mm:ss'),
        },
        msgInput.value,
      );
      this.connection.send(msg.tree());
      msgInput.value = '';
    }
  };

  handleClick = () => {
    const msgInput = this.refs.messageInput;
    if (msgInput.value !== '') {
      if ((this.connection && !this.connection.connected) || !this.connected) {
        this.reconnect();
      } else {
        this.sendMsg();
      }
    }
  };

  handleKeyDown = (e) => {
    if (!e) e = window.event;
    // eslint-disable-next-line eqeqeq
    if ((e.keyCode || e.which) == 13) {
      this.handleClick();
    }
  };

  onTabChange = async (id) => {
    await this.setState({
      selectedId: id,
    });
    const messageList = this.refs.messageList;
    if (id === 'chatList' && messageList && messageList.scrollHeight) {
      messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight;
    }
  };

  render() {
    const { tabList, selectedId, userList, chatList } = this.state;
    const chatListDom = (
      <div style={{ height: '100%' }}>
        <ul className="chat-list" ref="messageList">
          {chatList.map((item, index) => (
            <li className={`item${item.isMine ? ' mine' : ''}`} key={index}>
              <p className="user-name">{item.isMine ? '我' : item.user}</p>
              <p className="content">{item.text}</p>
            </li>
          ))}
        </ul>
        <div className="send-box">
          <input
            type="text"
            ref="messageInput"
            onKeyDown={this.handleKeyDown}
            maxLength="500"
            placeholder="请输入聊天内容"
          />
          <em onClick={this.sendMsg}>发送</em>
        </div>
      </div>
    );
    const memberListDom = (
      <ul className="member-list">
        {userList.map((item) => (
          <li key={item.id} className="item">
            {item.userName}
          </li>
        ))}
      </ul>
    );
    return (
      <div className={'chat'}>
        <div className="tab">
          {tabList.map((item) => (
            <span
              key={item.id}
              className={`item ${selectedId === item.id ? ' on' : ''}`}
              onClick={() => this.onTabChange(item.id)}
            >
              {item.name}
              <span style={{ color: '#91f891' }}>
                {item.id === 'members' ? `(${userList.length})` : null}
              </span>
            </span>
          ))}
        </div>
        <div className="tab-panel">{selectedId === 'chatList' ? chatListDom : memberListDom}</div>
      </div>
    );
  }
}

export default Openfire;
